import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { sendContactEmail } from '../services/contactEmail';

export default function Contact() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    company: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitState, setSubmitState] = useState({ type: '', message: '' });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitState({ type: '', message: '' });

    if (formData.company.trim()) {
      setSubmitState({ type: 'error', message: t.contact.status.botDetected });
      return;
    }

    if (!formData.name.trim() || !formData.email.trim() || !formData.subject.trim() || !formData.message.trim()) {
      setSubmitState({ type: 'error', message: t.contact.status.required });
      return;
    }

    if (!isValidEmail(formData.email.trim())) {
      setSubmitState({ type: 'error', message: t.contact.status.invalidEmail });
      return;
    }

    try {
      setIsSubmitting(true);
      setSubmitState({ type: 'info', message: t.contact.status.sending });

      await sendContactEmail({
        name: formData.name.trim(),
        email: formData.email.trim(),
        subject: formData.subject.trim(),
        message: formData.message.trim(),
      });
      setSubmitState({ type: 'success', message: t.contact.status.success });

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        company: '',
      });
    } catch (error) {
      const message = error?.message
        ? `${t.contact.status.error} (${error.message})`
        : t.contact.status.error;
      // Keep detailed reason in console for quick troubleshooting.
      console.error('Contact form send failed:', error);
      setSubmitState({ type: 'error', message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h1>{t.contact.title}</h1>
      
      <div className="working-hours">
        <h2>{t.contact.workingHours.title}</h2>
        <p><strong>{t.contact.workingHours.hours}</strong></p>
        <p>{t.contact.workingHours.reservation}</p>
        <p>{t.contact.workingHours.response}</p>
        <p>{t.contact.workingHours.documents}</p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
          {t.contact.form.name}
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={t.contact.form.namePlaceholder}
            autoComplete="name"
          />
        </label>
        <label>
          {t.contact.form.email}
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={t.contact.form.emailPlaceholder}
            autoComplete="email"
          />
        </label>
        <label>
          {t.contact.form.subject}
          <input
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder={t.contact.form.subjectPlaceholder}
          />
        </label>
        <label>
          {t.contact.form.message}
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder={t.contact.form.messagePlaceholder}
          />
        </label>
        <input
          className="hp-input"
          name="company"
          value={formData.company}
          onChange={handleChange}
          tabIndex="-1"
          autoComplete="off"
          aria-hidden="true"
        />
        {submitState.message && (
          <p className={`form-status ${submitState.type}`}>{submitState.message}</p>
        )}
        <button className="btn" type="submit" disabled={isSubmitting}>
          {isSubmitting ? t.contact.status.sending : t.contact.form.submit}
        </button>
      </form>
    </div>
  );
}
